import { render, staticRenderFns } from "./RemindCallHistoryNotification.vue?vue&type=template&id=27dc91d2"
import script from "./RemindCallHistoryNotification.vue?vue&type=script&lang=js"
export * from "./RemindCallHistoryNotification.vue?vue&type=script&lang=js"
import style0 from "./RemindCallHistoryNotification.vue?vue&type=style&index=0&id=27dc91d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports